
export default {
  name: "VerticalTabs",
  props: {
    features: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
      scroll: null,
    };
  },
  mounted() {
    this.scroll = this.$ScrollTrigger.create({
      trigger: ".content-container",
      start: "top 100px",
      end: "bottom+=500",
      scrub: 1,
      anticipatePin: 1,
      pin: ".main",
      pinSpacing: true,
      onUpdate: (self) => {
        const position = Number(
          (self.progress * (this.features.length - 1)).toFixed()
        );
        this.tab = position;
      },
    });
  },
  methods: {
    setTab(i) {
      if (i >= 0 && i < this.features.length) {
        this.scroll.scroll(
          this.scroll.start + (i / 5) * (this.scroll.end - this.scroll.start)
        );
      }
    },
  },
};
